import React from 'react'
import { cobranzasAPI } from '../../utils/funcionesAPI'
import {manejadorDeRespuesta} from '../../utils/Tools'
import {toast } from 'react-toastify'
import get from '../../utils/get'

class TarjetasBancoCuotasPedraza extends React.Component {

  constructor(props) {
      super(props)

      this.state = {bancos: [], tarjetas: [], cuotas: [], bancoElegido: 0};

      this.handleBancoChange = this.handleBancoChange.bind(this);
      this.handleTarjetaChange = this.handleTarjetaChange.bind(this);
      this.handleCuotaChange = this.handleCuotaChange.bind(this);
  }



  componentDidMount() {

    //this.traerBancos();
    this.traerTarjetas();
  }

  traerBancos() {

    let data = JSON.stringify({peticion: 'traerBancos'});
    cobranzasAPI(data)
            .then(respuesta => {
              if (manejadorDeRespuesta(this.props, respuesta)) {
                  this.setState({bancos: respuesta.data});
              }
            });
  }

  traerBancosPorTarjeta(idTarjeta) {

    let data = JSON.stringify({peticion: 'traerBancosPorTarjeta', idTarjeta});
    cobranzasAPI(data)
            .then(respuesta => {
              if (manejadorDeRespuesta(this.props, respuesta)) {
                  this.setState({bancos: respuesta.data});
              }
            });
  }

  traerTarjetas() {

    let data = JSON.stringify({peticion: 'traerTarjetasPedraza'});
    cobranzasAPI(data)
            .then(respuesta => {
              if (manejadorDeRespuesta(this.props, respuesta)) {
                  this.setState({tarjetas: respuesta.data});
              }
            });
  }

  traerCuotas(idTarjeta, idBanco) {
    const pais = get(this.props, 'producto.destino.pais', 'ARG');
    const idProducto = get(this.props, 'producto.idProducto');
    let data = JSON.stringify({peticion: 'traerCuotasSegunBancoTarjetaProducto', idBanco, idTarjeta, pais, idProducto});
    cobranzasAPI(data)
            .then(respuesta => {
              if (manejadorDeRespuesta(this.props, respuesta)) {
                  this.setState({cuotas: respuesta.data});
              }
            });
  }

  handleTarjetaChange(e) {
    const tarjetaEleg =  this.state.tarjetas.find((tarjeta) => tarjeta.id === e.target.value)
    const cuotaElegida = {id: 0, interes: 0, cantidad: 0};
    this.props.onTarjetaClick(tarjetaEleg, cuotaElegida);
    this.setState({bancoElegido: 0, cuotas: []});
    this.traerBancosPorTarjeta(e.target.value);
  }

  handleBancoChange(e) {

    if (this.props.tarjetaElegida.id === 0) {
      toast.info('Debe elegir una tarjeta primero', {
                            position: toast.POSITION.BOTTOM_CENTER
                            });
      return;
    }
/*
    if (this.props.onBancoClick) {
      this.props.onBancoClick(e.target.value);
    }
    */
    //FC: para la nueva implementacion de Prisma tengo que mandar el banco completo
   // if (this.props.onBancoClickFromPrisma) {
      const bancoSelected = this.state.bancos.find(b => b.id === e.target.value);
      const cuotaElegida = {id: 0, interes: 0, cantidad: 0};
      this.props.onTarjetaClick(this.props.tarjetaElegida, cuotaElegida);
      this.props.onBancoClick(bancoSelected);
   // }

    this.setState({bancoElegido: e.target.value});

    this.traerCuotas(this.props.tarjetaElegida.id, e.target.value);
  }


  handleCuotaChange(e) {
    const cuotaEleg =  this.state.cuotas.find((cuota) => cuota.id === e.target.value);
    this.props.onCuotaClick(cuotaEleg);

    //const subTotalImporteMasImpuesto = parseFloat(this.state.importeAPagar) + parseFloat(this.state.importeProporcionalRGPais);
    //const nuevoImporteAPagar = subTotalImporteMasImpuesto + parseFloat(( subTotalImporteMasImpuesto * cuotaEleg.interes / 100)) ;
    //this.setState({cuotaElegida: cuotaEleg, importeAPagarConImpuestosYIntereses: nuevoImporteAPagar});
  }


  render() {
      return (
            <div style={{padding: '0'}} className="input-container col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 datos-personales">
              <div className="fieldset row bg">
                <div className="select-container" style={{width: '100%'}}>
                  <label style={{marginTop: '10px', display: 'block', marginLeft: '5px'}} className="labelForm text-left">Seleccionar Tarjeta de Crédito</label>
                  <select className="selectPagoConTarjeta form-control" name="tarjeta" id="tarjeta" onChange={this.handleTarjetaChange}>
                    <option value='0'>Seleccionar Tarjeta</option>
                    {
                      this.state.tarjetas.map(tarjeta => {
                        return <option key={tarjeta.id} value={tarjeta.id}>{tarjeta.denominacion}</option>
                      })
                    }
                  </select>
                </div>
                <div className="select-container" style={{width: '100%'}}>
                  <label style={{marginTop: '10px', display: 'block', marginLeft: '5px'}} className="labelForm text-left labelForm">Seleccionar Banco Emisor</label>
                  <select className="selectPagoConTarjeta form-control" value={this.state.bancoElegido} name="banco" id="banco" onChange={this.handleBancoChange}>
                    <option value='0'>Seleccionar Banco Emisor</option>
                    {
                      this.state.bancos.map(banco => {
                        return <option key={banco.id} value={banco.id}>{banco.denominacion}</option>
                      })
                    }
                  </select>
                </div>
                <div className="select-container" style={{width: '100%'}}>
                  <label style={{marginTop: '10px', display: 'block', marginLeft: '5px'}} className="labelForm text-left">Seleccionar Plan de Cuotas</label>
                  <select className="selectPagoConTarjeta form-control" name="cuotas" id="cuotas" onChange={this.handleCuotaChange}>
                    <option value='0'>Seleccionar Cuotas</option>
                    {
                      this.state.cuotas.map(cuota => {
                        return <option key={cuota.id} value={cuota.id}>{cuota.descripcion}</option>
                      })
                    }
                  </select>
                </div>
              </div>
            </div>
      )

  }
}

export default TarjetasBancoCuotasPedraza



// WEBPACK FOOTER //
// ./src/components/Global/TarjetasBancoCuotasPedraza.js